import { render } from "./PracticalInfo.vue?vue&type=template&id=441185ec&scoped=true"
import script from "./PracticalInfo.vue?vue&type=script&lang=js"
export * from "./PracticalInfo.vue?vue&type=script&lang=js"

import "./PracticalInfo.vue?vue&type=style&index=0&id=441185ec&scoped=true&lang=css"
import "./PracticalInfo.vue?vue&type=style&index=1&id=441185ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441185ec"]])

export default __exports__